import React,{Component} from 'react'
import Link from 'react-router'
import {language} from 'UTIL/common'
export default class ModalFooter extends Component{
     render(){
        return (
            <div className="modal-footer">
                <button type="button" className="btn btn-default"
                        data-dismiss="modal">{language()['close']}
                </button> 
                <button type="button" className="btn btn-info" data-dismiss="modal"
                    onClick={this.props.modClick}>{language()['sure']}
                </button> 
            </div>
        )
     }
}


// WEBPACK FOOTER //
// ./modules/component/modalFooter.js